


































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import dialogComp from '@/components/dialog/index.vue';
import qs from 'qs';
@Component<VBANNER>({
  components: {
    dialogComp,
  },
})
export default class VBANNER extends Vue {
  public show() {
    (this.$refs.dialog as any).show();
  }
  public userName: string = '';
  public userPhone: string = '';
  public tipType: string = '';
  public provinceList: any = [];
  public cityList: any = [{name:'请选择',value:''}];
  public province: string = '';
  public city: string = '';
  public handleGet() {
    var reg = /^1[3456789]\d{9}$/gi;
    let dialog = this.$dialog as any;
    if(this.province == ''){
      dialog.alert({
        message: '请选择省份',
      });
      return;
    }
    if(this.city == ''){
      dialog.alert({
        message: '请选择城市',
      });
      return;
    }
    if (this.userName == '') {
      dialog.alert({
        message: '请输入姓名',
      });
    } else if (this.userPhone == '') {
      dialog.alert({
        message: '请输入手机号',
      });
    } else if (!reg.test(this.userPhone)) {
      dialog.alert({
        message: '请输入正确的手机号',
      });
    } else {
      this.callback(
        { userName: this.userName, userPhone: this.userPhone,province:this.province,city:this.city },
        this.close,
      );
    }
  }
  public mounted() {
    this.initProvinceList();
  }
  public changeProvince(e: any) {
    this.city = '';
    this.province = e.target.value;
    this.initCityList(this.province);
  }
  public initProvinceList() {
    (this as any).$axios.get('/keepInfo/provinces').then((res: any) => {
      let provinceList = [{ name: '请选择', value: '' }];
      res.data.forEach((item: any) => {
        provinceList.push({
          name: item,
          value: item,
        });
      });
      this.provinceList = provinceList;
    });
  }
  public initCityList(province: string) {
    (this as any).$axios
      .get('/keepInfo/cities?province=' + province)
      .then((res: any) => {
        let cityList = [{ name: '请选择', value: '' }];
        res.data.forEach((item: any) => {
          cityList.push({
            name: item,
            value: item,
          });
        });
        this.cityList = cityList;
      });
  }
  public close() {
    (this.$refs.dialog as any).close();
  }
  public callback(params: any, close: any) {}
}
